import React, { FC } from 'react';
import { VerifyTalentCardSkeleton } from '@src/components/VerifyTalentCard/Skeleton';
import { ActivityFeedItem as VerifyTalentCard } from '@src/components/VerifyTalentCard/ActivityFeedItem';
import { ModalOptions } from '@src/components/VerifyTalentCard/InviteToInterview/props';
import { EmptyState } from '../EmptyState';
import { Props } from './props';
import './styles.scss';

export const MODAL_OPTIONS: ModalOptions = {
  shouldHideTalentSave: true,
};

export const TalentsFeed: FC<Props> = ({ talentFeed, isLoading, urlLocation, onOpeningPositionClick, onMessaged }) => {
  return (
    <div className="talents-feed-wrapper">
      {talentFeed.map(item => {
        const openingId = item.signal.entity.id;

        return (
          <VerifyTalentCard
            key={item.talent.user.id}
            modalOptions={MODAL_OPTIONS}
            onMessaged={onMessaged}
            onOpeningPositionClick={() => onOpeningPositionClick(openingId)}
            talentData={item}
            urlLocation={urlLocation}
          />
        );
      })}
      {!isLoading && !talentFeed.length && <EmptyState />}
      {isLoading && (
        <>
          <VerifyTalentCardSkeleton />
          <VerifyTalentCardSkeleton />
        </>
      )}
    </div>
  );
};
